import "./register.scss";
import SignUp from "../../components/sign-up";
const Register = () => {
  return (
    <>
    <div className="register-container">
        <div className="sign-up-section">
              <SignUp/>
         </div>
    </div>
  
    </>
  );
};

export default Register;
